import { render, staticRenderFns } from "./howToArticle.vue?vue&type=template&id=163a2b44&scoped=true"
import script from "./howToArticle.vue?vue&type=script&lang=js"
export * from "./howToArticle.vue?vue&type=script&lang=js"
import style0 from "./howToArticle.vue?vue&type=style&index=0&id=163a2b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163a2b44",
  null
  
)

export default component.exports